import React, { FC } from 'react'

import SocketProvider from './context/SocketProvider'

export const wrapRootElement: FC<{ element: React.ReactChild }> = ({ element }) => (
	<SocketProvider>{element}</SocketProvider>
)
